// Quem vê as telas de plantão do Service Desk. Admin sempre vê (configura a escala
// de todo mundo); o resto só se tiver um dos níveis pedidos. Sem nível = fora do suporte.
export type SupportLevel = 'n1' | 'n2' | 'n3'

export const ALL_SUPPORT_LEVELS: readonly SupportLevel[] = ['n1', 'n2', 'n3']

export function canAccessSupport(
  required: readonly string[] | undefined,
  user: { isAdmin: boolean; supportLevel: string | null },
): boolean {
  if (!required) return true
  if (user.isAdmin) return true
  return !!user.supportLevel && required.includes(user.supportLevel)
}
